import { gql } from '@apollo/client'

export const CURRENT_USER_AND_PROJECT_QUERY = gql`
  query ($projectId: String!) {
    me {
      id
      email
    }
    project(id: $projectId) {
      id
      content
    }
  }
`
